import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AuthBridgeService {
    private loggedInCache: Promise<boolean>;

    private isLoggedIn(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const frame = document.createElement('iframe');
            const listener = e => {
                try {
                    if (e.data.type === 'getCurrentUser') {
                        window.removeEventListener('message', listener);
                        document.body.removeChild(frame);
                        resolve(e.data.response);
                    }
                } catch (error) {
                    console.error(error);
                    reject(error);
                }
            };

            window.addEventListener('message', listener);
            frame.style.visibility = 'hidden';
            frame.style.display = 'none';
            frame.src = 'https://app.appodeal.com/auth-bridge';
            document.body.append(frame);
        })
            .then(user => !!user)
            .catch(err => false);
    }

    // function helps you to determine on demo page
    // if user actually signed up on app.appodeal.com
    isUserLoggedIn(): Promise<boolean> {
        if (!this.loggedInCache) {
            this.loggedInCache = new Promise(resolve => this.isLoggedIn().then(resolve));
        }
        return this.loggedInCache;
    }
}
